import React, { useState, useEffect } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SetupAccountPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();
  const { checkSession } = useAuth();

  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/setup-account`, { token, password, name: name || undefined }, { withCredentials: true });
      await checkSession();
      navigate('/portal/client');
    } catch (err) {
      setError(err.response?.data?.detail || 'Setup failed');
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div className="py-20 px-6 text-center">
        <p className="text-sm text-[#6B6B6B]">Invalid invitation link.</p>
        <Link to="/login" className="text-sm text-[#1A1A1A] underline mt-2 inline-block">Go to login</Link>
      </div>
    );
  }

  return (
    <div data-testid="page-setup-account">
      <section className="py-20 px-6">
        <div className="max-w-sm mx-auto">
          <div className="text-center mb-8">
            <p className="font-serif text-xl text-[#1A1A1A] mb-2">Welcome to Verault Travels</p>
            <p className="text-sm text-[#6B6B6B]">Set up your account to access your Member Suite.</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="setup-form">
            {error && <div className="p-3 bg-red-50 border border-red-200 rounded text-sm text-red-700">{error}</div>}
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-[#999] block mb-1">Your Name</label>
              <input type="text" value={name} onChange={e => setName(e.target.value)}
                className="w-full border border-[#E8E4DC] rounded px-4 py-2.5 text-sm bg-white focus:outline-none focus:border-[#1A1A1A]" data-testid="setup-name" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-[#999] block mb-1">Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={8}
                className="w-full border border-[#E8E4DC] rounded px-4 py-2.5 text-sm bg-white focus:outline-none focus:border-[#1A1A1A]" data-testid="setup-password" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.15em] text-[#999] block mb-1">Confirm Password</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={8}
                className="w-full border border-[#E8E4DC] rounded px-4 py-2.5 text-sm bg-white focus:outline-none focus:border-[#1A1A1A]" data-testid="setup-confirm" />
            </div>
            <button type="submit" disabled={loading} className="w-full py-3 bg-[#1A1A1A] text-white text-sm rounded hover:bg-[#333] transition-colors disabled:opacity-50" data-testid="setup-submit">
              {loading ? 'Setting up...' : 'Create Account'}
            </button>
          </form>

          <div className="mt-8 text-center">
            <Link to="/login" className="text-sm text-[#6B6B6B] hover:text-[#1A1A1A]">Already have an account? Sign in</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
